import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

export type DocumentItemsState = CommonTableState & {
    refetchIndicator: number;
};

const initialState: DocumentItemsState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: false }],
        columnPinning: {
            right: ["mrt-row-actions"],
        },
        columnVisibility: {
            miningStatus: false,
            description: false,
            modified: false,
            kind: false,
            "currency.code": false,
            "processor.id": false,
            created: false,
        },
        pagination: {
            pageIndex: 0,
            pageSize: 1000,
        },
        columnOrder: [
            "text",
            "base",
            "vatRate",
            "tax",
            "amountVat",
            "preAccounting.id",
            "centre.id",
            "activity.id",
            "contract.id",
            "created",
            "mrt-row-actions",
        ],
        density: "compact",
    },
    refetchIndicator: 0,
};

export const documentItemsSlice = createSlice({
    name: "documentItems",
    initialState,
    reducers: {
        refetchDocumentItemsTable: (state) => {
            state.refetchIndicator += 1;
        },
        updateDocumentItemsTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

// Action creators are generated for each case reducer function
export const { updateDocumentItemsTableState, refetchDocumentItemsTable } = documentItemsSlice.actions;

export default documentItemsSlice.reducer;
